import {
    ProtectionPlanTypes,
    REQUEST_PROTECTION_PLAN,
    RECEIVE_PROTECTION_PLAN,
    IProtectionPlanResponse,
    IProduct,
    IPackage,
    IReceiveContractChange,
    RECEIVE_CONTRACT_CHANGE,
} from "./types";
import { AppThunkAction } from "../..";
import * as services from "../../service";
export const actionCreators = {
    requestProtectionPlan:
        (forceFullyRefresh: boolean): AppThunkAction<ProtectionPlanTypes> =>
        (dispatch, getState) => {
            const appState = getState();
            const isPayAsYouGo =
                appState.configurationState && appState.configurationState.configuration.partnerConfig.partnerId
                    ? appState.configurationState.configuration.partnerConfig.partnerId === 2559
                        ? true
                        : false
                    : false;

            const productSortingNullLast = (ascending: boolean) => {
                return function (a: IProduct, b: IProduct) {
                    if (a.orderBy === null) {
                        return 1;
                    } else if (b.orderBy === null) {
                        return -1;
                    } else if (a.orderBy === b.orderBy) {
                        return 0;
                    } else if (!ascending) {
                        return a.orderBy < b.orderBy ? 1 : -1;
                    } else {
                        return a.orderBy < b.orderBy ? -1 : 1;
                    }
                };
            };

            const calculateYearlySaving = (PackagePrice: number, PackagePriceYearly: number) => {
                let yearlySaving = "";
                const overallCostYearly = PackagePrice * 12;
                if (PackagePriceYearly === 0) {
                    yearlySaving = "0.00";
                } else if (overallCostYearly !== 0 && PackagePriceYearly !== 0) {
                    const saving = ((overallCostYearly - PackagePriceYearly) / overallCostYearly) * 100;
                    yearlySaving = saving.toFixed(2);
                }
                return yearlySaving;
            };

            const displayPaymentInfo = (pkg: IPackage) => {
                if (Number(pkg.PartnerId) === 428) {
                    return false;
                }
                //return pkg.DisplayPaymentInfo;
                return true;
            };

            const priceToDisplay = (pkg: IPackage) => {
                let price: number = 0;
                if (pkg.SubcriptionType?.toLowerCase() === "monthly") {
                    price = pkg.PackagePrice;
                } else if (pkg.SubcriptionType?.toLowerCase() === "yearly") {
                    price = pkg.PackagePriceYearly;
                }
                return price;
            };

            const showBillingText = (pkg: IPackage) => {
                // to solve bug: 18196
                if (pkg.IsBusinessUser) {
                    if (pkg.IsBusinessUser && !pkg.IsPSS && pkg.IsUserPaid) {
                        return true;
                    }
                } else {
                    // Logic implemented to resolve BUG - 15366
                    // where partner ID for commerce bank = 428
                    if (Number(pkg.PartnerId) === 428 && pkg.IsUserPaid === false) {
                        return true;
                    } else if (pkg.IsUserPaid && pkg.Price !== 0) {
                        return true;
                    } else {
                        return false;
                    }
                }
            };

            const prepareBillingText = (text: any) => {
                let billingText = "";
                if (text && text.length > 0) {
                    billingText = text[0].toUpperCase() + text.substring(1);
                }
                return billingText;
            };

            let protectionPlanData: IProtectionPlanResponse;

            if (
                appState != null &&
                appState.protectionPlanState != null &&
                ((appState.protectionPlanState.protectionPlanData?.packageList == null && appState.protectionPlanState.isLoading === false) ||
                    forceFullyRefresh === true)
            ) {
                services
                    .getProtectionPlan(isPayAsYouGo)
                    .then((planData) => {
                        let data: any;
                        if (planData !== null && planData !== "") {
                            data = JSON.parse(planData);
                        }
                        if (data != null && data.IsChildUser != null && data.IsChildUser) {
                            if (data.PackageInformation) {
                                data.PackageInformation.forEach(function (obj: any) {
                                    obj.IsPackageCancel = false;
                                });
                            }
                        }

                        var packages: IPackage[] = [];
                        var productList: IProduct[] = [];
                        if (data.IsSuccess) {
                            var maxRowID = -1;
                            let productRowId = 0;

                            data.PackageInformation.forEach(function (pkg: IPackage) {
                                let products: IProduct[] = pkg.Products ? pkg.Products : [];
                                products.sort(productSortingNullLast(true));
                            });

                            data.PackageInformation.forEach(function (obj: any) {
                                var products: any = [];
                                obj.Products.forEach(function (product: any) {
                                    // Bug# 20702,22287: Remove Service from Product List by ID for Service, Transaction Authentication, ServiceCode: SVCLVL-TU-AUTH
                                    // Bug 26245: Hide Transactional Authentication service from Protection Plan and Package Matrix on both Test and stage for TU canada packages
                                    // Task 25408: Hide credit notification only service from protection plan.
                                    if (!product.IsHidden && product.Id !== 182 && product.Id !== 168 && product.Id !== 191 && product.Id !== 197) {
                                        let thisRowId = 0;
                                        const foundProduct = productList.find(
                                            (it: IProduct) =>
                                                (product.Parent != null && it.parent === product.Parent) || (product.Parent == null && it.id === product.Id)
                                        );

                                        if (foundProduct == null) {
                                            let tempProduct: IProduct = {
                                                parent: product.Parent,
                                                id: product.Id,
                                                displayName: product.Parent != null ? product.ParentDisplayName : product.DisplayName,
                                                description: product.Description,
                                                rowId: productRowId,
                                                name: "",
                                                labelText: "",
                                                orderBy: product.OrderBy,
                                                isAddOnService: product.IsAddOnService,
                                            };

                                            productList.push(tempProduct);

                                            productRowId++;
                                            maxRowID++;
                                            thisRowId = maxRowID;
                                        } else {
                                            thisRowId = Number(foundProduct.rowId);
                                        }

                                        const productAlreadyAdded = products.find((it: IProduct) => it.id === product.Id);
                                        if (!productAlreadyAdded) {
                                            const hasAddonProduct: boolean = obj.Products?.find((it: any) => it.Id === product.Id && it.IsAddOnService)
                                                ? true
                                                : false;
                                            let prd: IProduct = {
                                                id: product.Id,
                                                parent: product.Parent,
                                                name: product.Name,
                                                rowId: thisRowId,
                                                labelText: product.LebelText === "" ? "==tick==" : product.LebelText,
                                                displayName: product.DisplayName,
                                                orderBy: product.OrderBy,
                                                isAddOnService: product.IsAddOnService || hasAddonProduct,
                                            };
                                            products.push(prd);
                                        }
                                    }
                                });

                                var tempPackage: IPackage = {
                                    BasePackagePrice: Number(obj.BasePackagePrice),
                                    BillingText: prepareBillingText(obj.BillingText),
                                    HasUserCancelled: obj.HasUserCancelled,
                                    IsActive: obj.IsActive,
                                    IsPacakgeUpgradable: obj.IsPacakgeUpgradable,
                                    IsPackageCancel: obj.IsPackageCancel,
                                    PackagId: obj.PackagId,
                                    PackageCode: obj.PackageCode,
                                    PackageName: obj.PackageName,
                                    PackagePrice: Number(obj.PackagePrice),
                                    PackagePriceYearly: Number(obj.PackagePriceYearly),
                                    DisplayPrice: data.DisplayPrice,
                                    SubcriptionType: obj.SubcriptionType,
                                    PartnerId: data.PartnerId,
                                    PartnerName: obj.PartnerName,
                                    ActionButtonText: "",
                                    Products: products,
                                    ShowCrossOut: obj.ShowCrossOut,
                                    DisplayPaymentInfo: data.DisplayPaymentInfo,
                                    IsPSS: obj.IsPSS,
                                    IsUserPaid: obj.IsUserPaid,
                                    IsBusinessUser: data.IsBusiness,
                                    ProvidedBy: obj.ProvidedBy,
                                    RemainingTrialDays: data.RemainingTrialDays,
                                    // UI Logic only
                                    ShowSubscriptionTypeChangeText: data.PartnerSubcritionType?.toUpperCase() === "BOTH",
                                    YearlySavingPrice: calculateYearlySaving(Number(obj.PackagePrice), Number(obj.PackagePriceYearly)),
                                    BasePackagePriceYearly: Number(obj.BasePackagePriceYearly),
                                    ShowBillingText: false,
                                    PackageValue: Number(obj.PackageValue),
                                    PacakgeType:obj.PacakgeType
                                };
                                packages.push(tempPackage);
                            });
                            packages.forEach(function (pkg: IPackage) {
                                pkg.Price = priceToDisplay(pkg);
                                pkg.ShowBillingText = showBillingText(pkg);
                                pkg.DisplayPaymentInfo = displayPaymentInfo(pkg);

                                let products: IProduct[] = pkg.Products ? pkg.Products : [];
                                for (let i = 0; i < productList.length; i++) {
                                    const foundProduct = products.find((it: IProduct) => it.rowId === i);
                                    if (foundProduct == null) {
                                        let prd: IProduct = {
                                            id: -1,
                                            rowId: i,
                                            labelText: "==cross==",
                                            name: "",
                                        };
                                        products.push(prd);
                                    }
                                }
                                let sortedProducts = products.sort((a: IProduct, b: IProduct) => (a.rowId > b.rowId ? 1 : -1));

                                pkg.Products = sortedProducts;
                            });
                        }
                        /*Bug# 19146- [EZS] Protection plan >  Plan display order is not appropriate on protection plan screen. 
                     Order Display as per PackageValue Ascending
                     */
                      
                        if (!(["BYORDER", "BYPRICE"].includes(data.PackageUpgradeDowngradeOrderBy))) {
                            packages.sort(function (a, b) {
                                return (a.PackageValue ? a.PackageValue : 0) - (b.PackageValue ? b.PackageValue : 0);
                            });
                        } 
  
                        const currentPackage: any = packages.find((it) => it.IsActive);
                        packages.forEach(function (pkg: IPackage, index: number) {
                            if (!currentPackage) {
                                pkg.ActionButtonText = "Purchase";
                            } else {
                               
                                if (pkg.IsActive == false) {
                                    pkg.ActionButtonText = "Select";
                                }
                                else
                                {
                                    pkg.ActionButtonText = "Cancel";
                                }
                               
                            }
                        });

                        protectionPlanData = {
                            packageList: packages,
                            productList: productList,
                        };

                        dispatch({ type: RECEIVE_PROTECTION_PLAN, protectionPlanData: protectionPlanData });
                    })
                    .catch(function (error) {
                        dispatch({ type: RECEIVE_PROTECTION_PLAN, protectionPlanData: protectionPlanData });
                    });

                dispatch({ type: REQUEST_PROTECTION_PLAN });
            }
        },
    checkContractChange:
        (operation: string, globalOfferCode: string): AppThunkAction<IReceiveContractChange> =>
        (dispatch, getState) => {
            if (operation === "contractChange") {
                services
                    .GetContractChangeDetails()
                    .then((data) => {
                        if (data != null && data !== "") {
                            const appState = getState();
                            let contractChangeJSON = JSON.parse(data);
                            dispatch({ type: RECEIVE_CONTRACT_CHANGE, data: { ...appState.checkContractChangeState, contractChangeData: contractChangeJSON } });
                        }
                    })
                    .catch(function (error) {});
            } else if (operation === "cancelletionContinuation") {
                services
                    .GetContractChangeDetails()
                    .then((data) => {
                        if (data != null && data !== "") {
                            let contractChangeJSON = JSON.parse(data);
                            const appState = getState();
                            services
                                .GetCancellationContinuationView(globalOfferCode)
                                .then((cacelletionContData) => {
                                    let cancellationContinuationJSON = JSON.parse(cacelletionContData);
                                    cancellationContinuationJSON.IsOffercodeApplied = globalOfferCode == null || globalOfferCode.length === 0 ? false : true;
                                    dispatch({
                                        type: RECEIVE_CONTRACT_CHANGE,
                                        data: {
                                            ...appState.checkContractChangeState,
                                            contractChangeData: contractChangeJSON,
                                            cancellatinoContinuationData: cancellationContinuationJSON,
                                        },
                                    });
                                })
                                .catch(function (error) {
                                    console.log(error);
                                });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        },
    setLoginFromUrl:
        (fromRedirectUrl: boolean): AppThunkAction<IReceiveContractChange> =>
        (dispatch, getState) => {
            const appState = getState();
            dispatch({ type: RECEIVE_CONTRACT_CHANGE, data: { ...appState.checkContractChangeState, fromRedirectUrl: fromRedirectUrl } });
        },
};
